/**
 * Shared utilities for building LaTeX expression strings from function params.
 */

/**
 * Format a number for display in a LaTeX expression.
 * Strips trailing zeros and uses at most 4 decimal places.
 */
export function formatCoefficient(value: number, precision = 4): string {
  const str = value.toFixed(precision);
  // Strip trailing zeros after decimal point
  return str.replace(/\.?0+$/, '');
}

/**
 * Build a signed term string for LaTeX, handling sign display.
 * Returns `+ value` or `- |value|` depending on sign.
 */
export function signedTerm(value: number, precision = 4): string {
  if (value >= 0) {
    return `+ ${formatCoefficient(value, precision)}`;
  }
  return `- ${formatCoefficient(-value, precision)}`;
}
